module.exports = __webpack_public_path__ + "staticVue/img/one.af845509.png";